import React, {Fragment} from 'react';
import CodelistsList from "./List";
import {connect} from "react-redux";
import ReduxCodelistDetailModal from "../../../redux-components/redux-codelist-detail-modal";
import {MM_CODELISTS_PREFIX} from "./reducer";
import ArtefactFullExportForm from "../../../redux-components/redux-artefact-full-export";

const mapStateToProps = state => ({
  codelistDetail: state.scenes.metaManager.codelists.codelistDetail,
});

const Codelists = ({
                     codelistDetail
                   }) =>
  <Fragment>
    <CodelistsList/>
    <ReduxCodelistDetailModal
      instancePrefix={MM_CODELISTS_PREFIX}
      instanceState={codelistDetail}
    />
    <ArtefactFullExportForm/>
  </Fragment>;

export default connect(mapStateToProps)(Codelists);
